var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.modules && !!_vm.modules['meter_data'])?_c('router-link',{staticClass:"btn btn-link ml-auto",attrs:{"to":"/app/inventory/utilitymetertypes"}},[_c('fa-icon',{attrs:{"icon":"chart-area"}}),_vm._v(" Utility Types ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }